/*----- Core -----*/
import { takeLatest, put, call } from 'redux-saga/effects'

/*----- Components -----*/
import Notification from "../../../../components/commons/Notification"

/*----- Constants -----*/
import {
 	CREATE_PRODUCER,
  CREATE_PRODUCER_SUCCESS,
	CREATE_PRODUCER_FAIL
} from './Constants'

import { PRODUCERS, PROFILE_PICS } from '../../../app/Constants'

/*----- Firestore -----*/
import { db } from '../../../../Firebase'
import imageLoader from '../../../../modules/imageLoader'

/*----- Constants -----*/

function* shootCreateProducer({ payload }) {

	function* addImagesIntoDoc(producerId, imageUrl) {
		const imageStructure = { images: imageUrl}
		yield db.collection(PRODUCERS)
				  .doc(producerId)
					.update(imageStructure)
		yield	Notification('Se creó correctamente el producto', 'success')
		yield put({type: CREATE_PRODUCER_SUCCESS, payload: payload })
	}

	function* createProduct() {
		let producerId
		try {
			yield db.collection(PRODUCERS).add({ ...payload })
						.then( (ref)=>	producerId = ref.id )
			let imageUrl = null
			if (payload.images) {
				imageUrl = yield imageLoader(payload.images, `${ PROFILE_PICS }/${ producerId }.jpg`)
			}
			/*** imageUrl: Images are processed and ready to send ***/
			yield call(addImagesIntoDoc,producerId,imageUrl)

		} catch (error) {

			yield Notification(error.message, 'error')
			yield console.log(error.message)

		}
	}
	
	try {
		yield call(createProduct)
	} catch (error) {
		yield put({type: CREATE_PRODUCER_FAIL, payload: error.message})
		yield console.log(error.message)
		yield Notification(error.message, 'error')
	}

}
export default function* createProducerWatcher() {
  yield takeLatest(CREATE_PRODUCER, shootCreateProducer)
}
